<template>
  <div class="page">
    <navigation class="header flex-shrink0">确认还款</navigation>
    <section class="section flex-shrink0">
      <div class="card">
        <div class="platform">
          <img class="icon" :src="platform.icon" />
          <span class="name">{{ platform.name }}</span>
        </div>

        <div class="card-amount">
          {{ totalAmount() | currency }}
          <img
            v-if="repaymentTrailInfo.hasWav"
            @click="showDetail"
            src="./images/icon_info.png"
            srcset="
                            ./images/icon_info@2x.png 2x,
                            ./images/icon_info@3x.png 3x
                        "
          />
        </div>
        <div class="card-amount-due" v-if="repaymentTrailInfo.hasWav">
          <span>应还金额：{{
            repaymentTrailInfo.beforWavAmount | currency
          }}</span>
        </div>

        <div class="repay-list">
          <span
            class="repay-list-item"
            v-if="repaymentTrailInfo.schdPrin"
          >应还本金：{{
            repaymentTrailInfo.schdPrin | currency
          }}</span>
          <span
            class="repay-list-item"
            v-if="repaymentTrailInfo.schdInt"
          >利息：{{ repaymentTrailInfo.schdInt | currency }}</span>

          <span class="repay-list-item" v-if="repaymentTrailInfo.fee">服务费：{{ repaymentTrailInfo.fee | currency }}</span>
          <span
            class="repay-list-item"
            v-if="repaymentTrailInfo.intDelay"
          >违约金：{{
            repaymentTrailInfo.intDelay | currency
          }}</span>
        </div>
      </div>

      <div class="repayment-type">
        <nd-choose
          name="type"
          v-model="form.type"
          :data="typeOptions"
          :valueKey="['key', 'description']"
          label="还款方式"
        >
          <label class="label"><img
            src="./images/icon_fangshi.png"
            srcset="
                                ./images/icon_fangshi@2x.png 2x,
                                ./images/icon_fangshi@3x.png 3x
                            "
          />还款方式</label>
        </nd-choose>
      </div>

      <dl class="repayment-account" v-if="form.type === 'ONLINE'">
        <dt class="label" :class="{ noneBorder: !bankcardList.length }">
          <img
            src="./images/icon_card.png"
            srcset="
                            ./images/icon_card@2x.png 2x,
                            ./images/icon_card@3x.png 3x
                        "
          />
          <span class="center">还款账户</span>
          <span
            class="right"
            v-if="!bankcardList.length"
            @click="toBind"
          >
            <span class="card-info">添加银行卡</span>
            <img
              class="arrow"
              src="../../components/nd-cell/images/arrow.png"
            />
          </span>
        </dt>
        <template v-if="bankcardList.length">
          <dd
            v-for="(item, index) in bankcardList"
            :key="`${item.bankCode}+${index}`"
          >
            <span class="bank-name">{{ item.bankName }} ({{
              item.bankCardNo.substr(-4)
            }})</span>
            <i class="select" @click="selectBankcard(item)">
              <img
                v-if="form.bankcard === item.bankCardNo"
                src="./images/selected.png"
                srcset="
                                    ./images/selected@2x.png 2x,
                                    ./images/selected@3x.png 3x
                                "
              />
              <img
                v-else
                src="./images/unselected.png"
                srcset="
                                    ./images/unselected@2x.png 2x,
                                    ./images/unselected@3x.png 3x
                                "
              />
            </i>
          </dd>
        </template>
      </dl>
      <div class="repament-decription" v-if="form.type === 'OFFLINE'">
        <div class="label">
          <img
            src="./images/icon_card.png"
            srcset="
                            ./images/icon_card@2x.png 2x,
                            ./images/icon_card@3x.png 3x
                        "
          />还款账户
        </div>
        <p>
          您可通过银行App转账还款或至银行办理转账还款
          您申请对账后，我们将尽快核实还款信息
        </p>
      </div>
      <div class="repayment-info" v-if="form.type === 'OFFLINE'">
        <div class="item">
          <label>借款平台</label><span>{{ platform.name }}</span>
        </div>
        <div class="item">
          <label>账户名称</label><span>{{ busAccInfo.accName || '' }}</span>
        </div>
        <div class="item">
          <label>开户银行</label><span>{{ busAccInfo.openBank || '' }}</span>
        </div>
        <div class="item">
          <label>卡&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</label><span>{{ busAccInfo.accNo || '' }}</span>
        </div>
      </div>
    </section>

    <div class="footer flex-shrink0">
      <nd-button
        v-if="form.type === 'ONLINE'"
        class="btn"
        @click="confirmRepay"
        :disabled="!disabled"
      >确认还款</nd-button>
      <nd-button v-else class="btn" @click="confirmRepay">我已还款，发起对账</nd-button>
    </div>

    <!-- 联系客服弹窗框 -->
    <nd-dialog
      v-model="detailDialogVisible"
      @close="closeDialog"
      :footer="false"
      :close-btn="true"
    >
      <div class="detail-dialog">
        <div class="title">应还金额</div>
        <div class="amount">
          ¥ {{ repaymentTrailInfo.repayAmount | currency }}
        </div>
        <div class="item">
          <div>
            <label class="des">本金(元)</label><span>{{
              repaymentTrailInfo.schdPrin | currency
            }}</span>
          </div>
          <div>
            <label class="des">利息(元)</label><span>{{
              repaymentTrailInfo.schdInt | currency
            }}</span>
          </div>
          <div v-if="repaymentTrailInfo.fee">
            <label class="des">服务费(元)</label><span>{{ repaymentTrailInfo.fee | currency }}</span>
          </div>
          <div v-if="repaymentTrailInfo.intDelay">
            <label class="des">违约金(元)</label><span>{{
              repaymentTrailInfo.intDelay | currency
            }}</span>
          </div>
          <div v-if="repaymentTrailInfo.wavInt">
            <label class="des">还款减免(元)</label><span>{{
              -repaymentTrailInfo.wavInt | currency
            }}</span>
          </div>
        </div>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import lfqIcon from '../../assets/images/lfq_icon.png'
import yzdIcon from '../../assets/images/yzd_icon.png'
import { mapActions, mapState } from 'vuex'
import { copyToClipbord } from '../../assets/utils'

export default {
  name: 'repayment-confirm',

  data () {
    return {
      orderId: this.$route.query.orderId || '',
      loanPlatform: this.$route.query.loanPlatform || 'YZD',
      fundCode: this.$route.query.fundCode || '',
      totalTerm: this.$route.query.totalTerm || 0, // 总期数
      canOffLineRepay: this.$route.query.canOffLineRepay || 'F',
      productCd: this.$route.query.productCd,
      detailDialogVisible: false,
      termList: this.$storage.get('selectedTerms'),
      repaymentTrailInfo: this.$storage.get('trail') || {},
      busAccInfo: {},
      form: { type: 'ONLINE', bankcard: null },
      selectedBankcard: {}
    }
  },

  async created () {
    try {
      if (this.canOffLineRepay === 'T') {
        await this.getBusAcc()
      }

      await this.getBankcardList()

      let hasDefaultCard = false

      if (this.bankcardList.length > 0) {
        for (let item of this.bankcardList) {
          if (item.default) {
            hasDefaultCard = true
            this.selectedBankcard = item
            this.form.bankcard = item.bankCardNo
            break
          }
        }
        if (!hasDefaultCard) {
          this.selectedBankcard = this.bankcardList[0]
          this.form.bankcard =
            this.bankcardList[0] && this.bankcardList[0].bankCardNo
        }
      }
      this.$bus.$emit('ready')
    } catch (error) {
      this.$bus.$emit('error')
    }
  },

  computed: {
    ...mapState('repay', {
      customServicePhone: (state) => {
        return state.busAcc.tel
      }
    }),
    ...mapState('bankcard', {
      bankcardList: (state) => state.bankcardList
    }),
    typeOptions () {
      return this.canOffLineRepay === 'T'
        ? [
          { key: 'ONLINE', description: '在线还款' },
          { key: 'OFFLINE', description: '线下还款' }
        ]
        : [{ key: 'ONLINE', description: '在线还款' }]
    },
    disabled () {
      return !!this.form.type && !!this.form.bankcard
    },
    platform () {
      if (this.loanPlatform === 'YZD') {
        return {
          icon: yzdIcon,
          name: '聚美颜值贷'
        }
      } else {
        return {
          icon: lfqIcon,
          name: '领分期'
        }
      }
    }
  },

  watch: {
    detailDialogVisible (value) {
      this.$report({
        id: 10104,
        args: {
          position: this.loanPlatform,
          target: this.form.type === 'ONLINE' ? 1 : 2,
          visible: value ? 1 : 0
        }
      })
    }
  },

  beforeRouteLeave (to, from, next) {
    this.$report({
      id: 10113,
      args: {
        target: this.form.type === 'ONLINE' ? 1 : 2
      }
    })
    next()
  },

  methods: {
    ...mapActions('repay', ['getBusAccX', 'repayApplyX']),
    ...mapActions('bankcard', ['getBankcardListX']),
    async getBankcardList () {
      const res = await this.getBankcardListX({
        productCd: this.productCd,
        loanPlatform: this.loanPlatform,
        fundCode: this.fundCode,
        termId: this.$route.query.termId || '1022656'
      })
      return res
    },
    selectBankcard (item) {
      this.selectedBankcard = item
      this.form.bankcard = item.bankCardNo
    },
    totalAmount () {
      return this.repaymentTrailInfo.repayAmount
    },

    closeDialog () {
      this.$report({
        id: 10062,
        args: {
          postion: 'page_reconciliation'
        }
      })
    },

    copyBankNo () {
      copyToClipbord(this.busAccInfo.accNo)
      this.$message('银行卡号复制成功')
    },

    async getBusAcc () {
      const params = {
        loanPlatform: this.loanPlatform,
        orderId: this.orderId,
        terms: this.termList.map((item) => item.repaymentIndex),
        fundCode: this.fundCode
      }
      const response = await this.getBusAccX(params)
      if (response.success) {
        this.busAccInfo = response.data || {}
      }
    },

    // 拨打电话
    callService () {
      this.$report({
        id: 10061,
        args: {
          position: 'page_reconciliation',
          target: this.busAccInfo.tel
        }
      })
      const element = document.createElement('a')
      const ev = document.createEvent('MouseEvents')
      ev.initEvent('click', false, true)

      element.href = `tel:${this.busAccInfo.tel}`
      document.body.appendChild(element)
      element.dispatchEvent(ev)
      document.body.removeChild(element)
    },

    async confirmRepay () {
      if (this.form.type === 'ONLINE' && this.selectedBankcard && this.selectedBankcard.invalid) {
        return this.reBind()
      }
      this.$report({
        id: 10102,
        args: {
          position: this.loanPlatform,
          target: this.form.type === 'ONLINE' ? 1 : 2
        }
      })
      const params = {
        repayMode: this.form.type,
        loanPlatform: this.loanPlatform,
        orderId: this.orderId,
        fundCode: this.fundCode,
        terms: this.termList.map((item) => item.repaymentIndex),
        totalAmt: this.repaymentTrailInfo.repayAmount,
        bankCardNo:
          this.form.type === 'ONLINE'
            ? this.form.bankcard
            : this.busAccInfo.accNo
      }
      const response = await this.repayApplyX(params)
      if (response.success) {
        this.$router.push({
          path: '/repayment/result',
          query: {
            repayId: response.data,
            loanPlatform: this.loanPlatform,
            type: this.form.type.toLowerCase(),
            orderId: this.orderId,
            fundCode: this.fundCode
          }
        })
      } else {
      }
    },

    showDetail () {
      this.$report({
        id: 10103,
        args: {
          position: this.loanPlatform,
          target: this.form.type === 'ONLINE' ? 1 : 2
        }
      })
      this.detailDialogVisible = true
    },

    repayDes (item) {
      if (item.termStatus === 'U') {
        return '待还'
      } else {
        return '逾期'
      }
    },

    repayClass (item) {
      if (item.termStatus === 'U') {
        return 'repay'
      } else {
        return 'overdue'
      }
    },
    toBind () {
      this.$router.push({
        path: '/bankcard/add',
        query: {
          position: 'repay',
          loanPlatform: this.$route.query.loanPlatform,
          fundCode: this.$route.query.fundCode,
          termId: this.$route.query.termId,
          orderId: this.$route.query.orderId,
          canChangePhoneNo:
            this.loanPlatform === 'YZD' ? 'false' : 'true'
        }
      })
    },
    // 重新绑卡
    reBind () {
      this.$router.push({
        path: '/bankcard/add',
        query: {
          position: 'repay',
          bankcardNo: this.form.bankcard,
          bankMobile: this.selectedBankcard.bankMobile,
          loanPlatform: this.$route.query.loanPlatform,
          fundCode: this.$route.query.fundCode,
          termId: this.$route.query.termId,
          orderId: this.$route.query.orderId,
          canChangePhoneNo:
            this.loanPlatform === 'YZD' ? 'false' : 'true'
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.flex-shrink0 {
    flex-shrink: 0;
}
.label {
    display: flex;
    align-items: center;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    > img {
        width: 44px;
        height: 44px;
        margin-right: 16px;
    }
    .center {
        flex: 1;
    }
    .right {
        display: flex;
        align-items: center;
        .card-info {
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 40px;
            margin-right: 8px;
        }
        .arrow {
            display: block;
            width: 11px;
            height: 20px;
        }
    }
}
.page {
    height: 100%;
    background-color: #fafafa;
    display: flex;
    flex-direction: column;
    .section {
        // overflow: scroll;
        flex: 1;
        padding: 30px;
        .card {
            border-radius: 20px;
            padding: 0 30px;
            padding-top: 22px;
            background-color: #ffffff;
            box-sizing: border-box;
            overflow: hidden;

            .platform {
                height: 36px;
                line-height: 36px;
                display: flex;
                flex-direction: row;
                align-items: center;

                .icon {
                    width: 36px;
                    height: 36px;
                }

                .name {
                    font-size: 26px;
                    padding-left: 8px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                }
            }

            .card-amount-due {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 13px;
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 33px;
                text-align: center;
                text-decoration: line-through;
            }

            .card-amount {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 65px;
                font-size: 72px;
                font-family: DIN-Medium, DIN;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                line-height: 67px;
                text-align: center;
                > img {
                    width: 23px;
                    height: 23px;
                    margin-left: 16px;
                }
            }

            .origin-amount {
                font-size: 24px;
                height: 33px;
                line-height: 33px;
                margin-top: 13px;
                margin-bottom: 73px;
                text-align: center;
                text-decoration: line-through;
                color: @fc3;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
            }
        }

        .repay-list {
            margin-top: 74px;
            margin-bottom: 45px;
            display: grid;
            grid-template-columns: 50% 50%;
            grid-row-gap: 7px;
            font-size: 24px;
            text-align: left;
            color: #333333;
            line-height: 33px;
            .repay-list-item {
                &:nth-child(2n) {
                    padding-left: 80px;
                }
            }
        }

        .repayment-type {
            margin-top: 30px;
            background-color: #ffffff;
            padding: 30px;
            border-radius: 20px;
        }
        .repayment-account {
            margin-top: 30px;
            background-color: #ffffff;
            border-radius: 20px;
            > dt {
                padding: 30px;
                padding-bottom: 30px;
                border-bottom: 1px solid #eee;
                &.noneBorder {
                    border-bottom: none;
                }
            }
            > dd {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 110px;
                margin-left: 90px;
                padding-right: 30px;
                font-size: 30px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                border-bottom: 1px solid #eee;
                &:last-child {
                    border-bottom: none;
                }
                > i > img {
                    display: block;
                    width: 32px;
                    height: 32px;
                }
            }
        }
        .repament-decription {
            margin-top: 30px;
            background-color: #ffffff;
            border-radius: 20px;
            padding: 30px;
            > p {
                margin-top: 40px;
                margin-left: 10px;
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 37px;
            }
        }
        .repayment-info {
            margin-top: 30px;
            background-color: #ffffff;
            border-radius: 20px;
            padding: 30px 40px;
            .item {
                display: flex;
                margin: 8px 0;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 40px;
                > label {
                    flex-shrink: 0;
                    width: 116px;
                    margin-right: 56px;
                    color: rgba(102, 102, 102, 1);
                }
            }
        }
    }

    .footer {
        height: 180px;
        background-color: #ffffff;

        .btn {
            margin: 28px auto 0;
        }
    }
    .detail-dialog {
        margin: 0px 0px 57px 45px;
        .title {
            font-size: 42px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 72px;
        }
        .amount {
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 32px;
            margin-top: 32px;
        }
        .item {
            margin-top: 32px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 40px;
            .des {
                display: inline-block;
                width: 180px;
            }
        }
    }
}
</style>
